import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { BrandScreen } from "../../screens/settings/BrandScreen.tsx";

/** `/settings/brand`: the company's logo and colours. */
export const Route = createFileRoute("/_app/settings/brand")({
  loader: ({ context }) => context.queryClient.prefetchQuery(actions.queryOptions("brand.get", {})),
  component: BrandScreen,
});
